import { render } from "./ReportCriterion.vue?vue&type=template&id=b010db64&scoped=true"
import script from "./ReportCriterion.vue?vue&type=script&lang=js"
export * from "./ReportCriterion.vue?vue&type=script&lang=js"

import "./ReportCriterion.vue?vue&type=style&index=0&id=b010db64&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b010db64"]])

export default __exports__